import GRID_ITEMS from '../gridItems';

function HomePage(){
    return (<><div className="banner"></div>

        <div className="container">
            <div className="section">
                <h2>Welcome to TriStar Engineers & Services</h2>
                <p>We are pioneers in POWER SOLUTIONS, providing reliable products and services for our customers.</p>
            </div>

            <div className="grid-container">
              {
                GRID_ITEMS.map(item => {
                  return (<div className="grid-item">
                    <h2>{item.heading}</h2>
                    <p>{item.description}</p>
                </div>);
                })
              }
            </div>
        </div>
    </>)
}

export default HomePage;